import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 bg-brand-cream overflow-hidden" data-id="element-16" data-mp="2prgzb5u7ihd9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17" data-mp="2ptkzbcoziw89">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-18" data-mp="2ts0rduzxausj">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative" data-id="element-19" data-mp="2ysy9y8ouhquk">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden relative z-10" data-id="element-20" data-mp="3hhv2o84lgbao">
              <img src="https://cdn.magicpatterns.com/uploads/ocrU2jQqSqLFEQcAeqs1Ch/Nalilu_лого_Монтажная_область_1_копия_15.jpg" alt="Логотип na.lilu — весь світ для тебе" className="w-full h-full object-cover" data-id="element-21" data-mp="3mjaqg7y5ovwr" />
            </div>
            {/* Decorative background element */}
            <div className="absolute -top-8 -left-8 w-full h-full border-2 border-brand-beige rounded-2xl z-0 hidden md:block" data-id="element-22" data-mp="2cqizexdvffj7" />
          </motion.div>

          {/* Text Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full lg:w-1/2" data-id="element-23" data-mp="27titcmh0ucs3">
            <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-24" data-mp="3o5xyq7tjyjhh">
              Історія na.lilu
            </h2>
            <div className="space-y-6 text-brand-dark/80 text-lg font-light leading-relaxed" data-id="element-25" data-mp="3jdeljbys1qd7">
              <p data-id="element-26" data-mp="67524jchpq8m">
                Народжений у самому серці України, na.lilu — це більше, ніж
                просто бренд одягу. Це оспівування сучасної жіночності, створене
                з непохитною відданістю якості та елегантності.
              </p>
              <p data-id="element-27" data-mp="1evjlodpfsgd">
                Кожна річ у нашій колекції ретельно продумана та бездоганно
                пошита. Ми обираємо преміальні тканини від перевірених
                європейських фабрик, гарантуючи, що наш одяг не лише виглядає
                вишукано, але й дарує відчуття розкоші на шкірі.
              </p>
              <p data-id="element-28" data-mp="3al3l84s0h8h6">
                Наша філософія проста: одяг має надихати вас. Чи то ідеально
                скроєний жакет для важливої зустрічі, чи струмлива шовкова сукня
                для особливого вечора, речі від na.lilu створені, щоб стати
                улюбленою основою вашого гардеробу на довгі роки.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-8 border-t border-brand-beige pt-10" data-id="element-29" data-mp="1crxxucsc05xd">
              <div data-id="element-30" data-mp="2x9yoaa1edapo">
                <h4 className="text-3xl font-serif text-brand-burgundy mb-2" data-id="element-31" data-mp="2tazp762ck865">
                  100%
                </h4>
                <p className="text-sm text-brand-dark/70 uppercase tracking-wider" data-id="element-32" data-mp="372e5340yjt8z">
                  Ручна робота в Україні
                </p>
              </div>
              <div data-id="element-33" data-mp="3h0agzy1pys85">
                <h4 className="text-3xl font-serif text-brand-burgundy mb-2" data-id="element-34" data-mp="3gzslx4qsmk1t">
                  Преміум
                </h4>
                <p className="text-sm text-brand-dark/70 uppercase tracking-wider" data-id="element-35" data-mp="3c0fpbsa4dym1">
                  Європейські тканини
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}